module.exports = __webpack_public_path__ + "static/media/rb_timetable_img_starguide_a@2x.4e0cfc8b.png";